<i (click)="onClick()" [ngClass]="[iconClass, iconStyleClass, disabled ? 'icon-button--disabled' : '']"></i>
